<mx-form-dialog [definition]="dialogDefinition">
  @let copy = organizationSelectors.copyOverrides | select;
  @if (copy?.PATRON_ITEM_REQUEST_ADDITIONAL_INSTRUCTIONS; as instructions) {
    <p class="whitespace-pre-line break-words">{{ instructions }}</p>
  }
  <mx-input-form-field fieldName="itemTitle" [formGroup]="formGroup"/>
  <mx-form-row class="gap-3">
    <mx-input-form-field fieldName="itemAuthor" overrideLabel="Author" [formGroup]="formGroup" class="w-1/2"/>
    <mx-input-form-field fieldName="isbn" overrideLabel="ISBN" [formGroup]="formGroup" class="w-1/2"/>
  </mx-form-row>
  <mx-form-row class="gap-3">
    <mx-input-form-field fieldName="materialTypeDesc" overrideLabel="Material Type" [formGroup]="formGroup" class="w-1/2"/>
    <mx-select-form-field fieldName="requestedBranchId" overrideLabel="Location for Pickup" [formGroup]="formGroup" class="w-1/2"
                          [options]="pickupBranchSelector | select: []" [includeUndefinedOption]="false"/>
  </mx-form-row>
  <mx-form-row class="gap-3">
    <mx-input-form-field fieldName="yearOfPublication" [formGroup]="formGroup" class="w-1/2"/>
    <mx-select-form-field fieldName="printType" [formGroup]="formGroup" class="w-1/2"
                          [options]="PRINT_TYPE_SELECT_OPTIONS"/>
  </mx-form-row>
  <mx-textarea-form-field fieldName="notes" [formGroup]="formGroup" [initialRows]="3"
                          placeholder="Add any helpful notes about your request (i.e. Publication Date, Edition, etc.)"/>
  <mx-checkbox-form-field fieldName="confirmCheckbox"
                          overrideLabel="I agree that I have searched the catalog and ILL and it is not in the library’s system already."
                          [formGroup]="formGroup"/>
</mx-form-dialog>
